import moment from "moment";
import { isInLifecycle, isPendingOrCompleted } from "./documentUtils";

export type ValidateFunc = () => boolean | Promise<boolean>;

export const getHasOutstandingBalance = (invoice: server.dto.InvoiceForList) => {
  if (!isPendingOrCompleted(invoice.lifeCycle.value)) return false;
  if (invoice.totalOutstanding == null) return false;

  return invoice.totalOutstanding.amount !== 0;
};

export const isInvoiceOverude = (invoice: server.dto.InvoiceV2) => {
  const dueDate = moment.utc(invoice.sendDate).add(invoice.dueInDays, "days");
  const isOverdue = moment.utc().isAfter(dueDate);
  return isOverdue && !isInLifecycle(invoice.lifeCycle.value, ["completed", "discarded"]);
};